export default __webpack_public_path__ + "static/media/m_engineering_card23_1.a1faca49.png";